import {
  alpha,
  Box,
  Grid,
  GridProps, Tooltip, tooltipClasses, TooltipProps
} from "@mui/material";

import { styled } from "@mui/material/styles";

export const CardCampaignsBox = styled(Grid)<GridProps & { $profilePage: boolean }>(({ theme }) => ({
  background: theme.linearGradients.gradientB,
  borderRadius: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  maxHeight: "50rem",
  padding: theme.spacing(3),

  [`${theme.breakpoints.down("sm")}`]: {
    padding: theme.spacing(2)
  }

}));

export const CardCampaignsItemsBox = styled(Grid)<GridProps & { showAll: boolean }>(() => ({
  // height: showAll ? "auto" : "10.5rem",
  height: "auto", //TODO da fixare il comportamento
  // alignItems:"center",
  display: "flex",
  flexDirection: "column"
  // gap:theme.spacing(3),
  // justifyContent:"center",
  // margin:"auto",
  // position:"relative"

}));

export const StyledPercentageItem = styled(Box)(({
  theme
}) => {
  return {
    // left:$left,
    position: "relative",
    // right:$right,

    display: "flex",
    flexDirection: "column",
    zIndex: 1,

    "& .RCP__progress": {
      filter: `drop-shadow(0px 0px 8px ${alpha(theme.palette.secondary?.main!, 0.85)})`
    },

    ".RCP": {
      width: "38px!important",
      height: "38px"
    },

    "svg": {
      overflow: "visible",
      width: "38px",
      height: "38px"
    },

    ".progress-left": {
      transform: "scaleX(-1);"
    },

    ".centered": {
      transform: "translateX(-14px)"
    }

  };
});

export const InfoTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip { ...props } classes={ { popper: className } } />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.customColors.backgroundCard
  },
  [`& .${tooltipClasses.arrow}::before`]: {
    border: `1px solid ${theme.customColors.border}`,
    backgroundColor: theme.customColors.backgroundCard
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: theme.customColors.backgroundCard,
    border: `1px solid ${theme.customColors.border}`,
    borderRadius: theme.spacing(1),
    color: theme.customColors.textWidget,
    fontSize: "0.75rem",
    maxWidth: "240px",
    padding: theme.spacing(1),
    textAlign: "center"
  }
}));
